import { Master } from './master';

export class StokListe {

  stokKodu: string;
  stokAdi: string;
  asgariStok: number;
  mevcutStok: number;
  talepEdilen: number;
  olcuBirimi: string;
  sonAlisFiyati: number;
  gecenSure: number;
  urunGrupId: number;
  dovizTipi: number;
  sarfYeri: Master = null;
  sarfYeriId: any;
  paraBirim: Master = null;
  paraBirimiId: any;
  subeKodu: number;
  ekAlan: string;
  birimFiyat: number;
  kdvOrani: number;
  muhasebeKodu: string;
  grupKodu: string;
  kod1: string;
  dovizAciklama: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
